// Note:
// The 'bad-words' library (https://github.com/web-mech/badwords) was used to filter profanity,
// but it can not handle the following case:
// - the string is not a single word (e.g.: "mother fucker", "ass hole")
// So that we need a customized version here.

import WordsList from './words-list'

const REPLACE_CHARACTER = '*'

// Because profane words can be surrounded by special characters,
// we need to escape them before processing the sentence
const escapeSpecialChars = (string) => {
  // escape special character, and then wrap each word with the word boundary (\b)
  return `\\b${string.replace(/[-/\s\\^$*+?.()|[\]{}]/g, '\\$&')}\\b`
}
const PROFANITY_REGEX = new RegExp(`${WordsList.map(escapeSpecialChars).join('|')}`, 'gim')
function filterProfanity(string) {
  string = string.trim()
  // Combine multiple spaces to single space character
  string = string.replace(/ +/g, ' ')
  const result = string.replace(PROFANITY_REGEX, (match) => {
    if (!match) {
      return null
    }
    if (/[^\w]/.test(match[match.length - 1])) {
      return `${REPLACE_CHARACTER.repeat(match.length - 1)}${match[match.length - 1]}`
    }
    return `${REPLACE_CHARACTER.repeat(match.length)}`
  })
  return result.trim()
}

export default (sentence) => {
  if (!sentence) return ''
  return filterProfanity(sentence)
}
